import React from 'react';
import { Table, Tabs, Select, Icon, Spin } from 'antd';
import SideNav from './SideNav';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
import Highcharts from 'react-highcharts';
import chartsConfig from '../common/chartsConfig';
import ExportUtil from '../../common/ExportUtil';

const { TabPane } = Tabs;
const { Option } = Select;

class ChartsFilter extends React.Component {
    state = {
        loading: false,
        params: {},
        data: [],
        panes: [],
        siteList: [],
        activeKey: '',
    }

    componentDidMount() {
        const { siteId } = sessionStorage;
        const panes = [{
            title: '汇总',
            key: '0',
            closable: false
        }, {
            title: '中心明细',
            key: '1',
            closable: false
        }];
        this.setState({
            panes,
            activeKey: '0',
            params: {
                investigationSiteId: siteId,
                optionDeep: '1',
            },
        }, () => {
            this.loadData();
            siteId == 0 && this.querySite();
        });
        chartsConfig.exporting.buttons.contextButton.menuItems = [
            'downloadJPEG', 'downloadPDF', 'downloadPNG', 'downloadSVG',
        ];
    }

    onChange = (activeKey) => {
        this.setState({ activeKey }, () => {
            let { panes, activeKey } = this.state;
            panes.map(item => {
                if (item.key == activeKey ) {
                    item.content = this.getContent();
                } else {
                    item.content = null;
                }
            });
            this.setState({ panes });
        });
    }

    loadData = () => {
        const { params, params: { investigationSiteId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.summary.queryScreenFailReason,
            data: { ...params },
            dateType: 'json',
            doneResult: res => {
                if (investigationSiteId == '0') {
                    this.setState({
                        subId: '',
                        subtitle: '',
                        loading: false,
                        data: res.data,
                        tableData: res.tableData,
                        siteData: res.investigationSites,
                    }, () => {
                        let { panes, activeKey } = this.state;
                        panes.map(item => {
                            if (item.key == activeKey ) {
                                item.content = this.getContent();
                            } else {
                                item.content = null;
                            }
                        });
                        this.setState({ panes });
                    });
                } else {
                    this.setState({
                        loading: false,
                        data: res.data,
                        tableData: res.tableData,
                    });
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options);
    }

    querySite = () => {
        const options = {
            method: 'POST',
            url: API_URL.site.list,
            data: {},
            dateType: 'json',
            doneResult: res => {
                const { datas = [] } = res.data.siteList;
                datas.unshift({ investigationSiteName: '中心汇总', investigationSiteId: 0 });
                this.setState({ siteList: datas });
            }
        }
        $.sendRequest(options);
    }

    loadSecondData = (params) => {
        const { investigationSiteId } = this.state.params;
        const options = {
            method: 'POST',
            url: API_URL.summary.queryScreenFailReasonById,
            data: {
                ...params,
                investigationSiteId,
            },
            dateType: 'json',
            doneResult: (res => {
                this.setState({
                    data: res.data,
                    tableData: res.tableData,
                    subId: params.filterFailOptionId,
                    subtitle: params.filterFailOptionValue,
                });
            })
        };
        $.sendRequest(options)
    }

    export = () => {
        const { params, subId } = this.state;
        const exportParams = { ... params };
        if (!exportParams.investigationSiteId || exportParams.investigationSiteId == '0') {
            delete exportParams.investigationSiteId;
        }
        let url = API_URL.summary.exportScreenFailReason;
        if (subId) {
            exportParams.filterFailOptionId = subId;
            url = API_URL.summary.exportScreenFailReasonById;
        }
        ExportUtil.export(exportParams, {}, url);
    }

    handleSelectChange = (value, key) => {
        const { params } = this.state;
        if (key == 'investigationSiteId') {
            params.optionDeep = '1';
        }
        params[key] = value;
        this.setState({
            params,
            activeKey: '0'
        }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const { tableData, params } = this.state;
        const { optionDeep } = params;
        let width;
        if (optionDeep == '1') {
            width = 105;
        } else if (optionDeep == '2' || optionDeep == '-1') {
            width = 140;
        }
        const columns = [{
            title: '筛选失败原因',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 90
        }];
        tableData.map((item, index) => {
            columns.push({
                title: item.filterFailOptionValue,
                dataIndex: `${item.filterFailOptionValue}_${index}`,
                key: `${item.filterFailOptionValue}_${index}`,
                width,
            })
        });
        return columns;
    }

    renderTotal = (text, record) => {
        const obj = {
            children: text,
            props: {},
        }
        if (record.index && (typeof record.index != 'number')) {
            obj.props.colSpan = 3;
        }
        return obj;
    }

    renderCommon = (text, record) => {
        const obj = {
            children: text,
            props: {},
        }
        if (record.index && (typeof record.index != 'number')) {
            obj.props.colSpan = 0;
        }
        return obj;
    }

    getSiteColumns = () => {
        const { tableData, siteData = [] } = this.state;
        const isFixed = tableData.length > 4;
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: isFixed && 'left',
            width: isFixed && 85,
            render: this.renderTotal
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            fixed: isFixed && 'left',
            width: isFixed && 100,
            render: this.renderCommon
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            fixed: isFixed && 'left',
            width: isFixed && 120,
            render: this.renderCommon
        }];

        if (siteData.length > 0) {
            siteData[0].filterStatisticTypes.map((item, index) => {
                columns.push({
                    title: item.filterFailOptionValue,
                    children: [{
                        title: '筛选失败数量',
                        dataIndex: `${item.filterFailOptionId}_count`,
                        key: `${item.filterFailOptionId}_count`,
                        width: isFixed && 90
                    }, {
                        title: '占比',
                        dataIndex: `${item.filterFailOptionId}_per`,
                        key: `${item.filterFailOptionId}_per`,
                        width: isFixed && 85
                    }]
                });
            });
        }
        return columns;
    }

    getSecondColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 85,
        render: this.renderTotal
    }, {
        title: '中心编号',
        dataIndex: 'investigationSiteCode',
        key: 'investigationSiteCode',
        render: this.renderCommon
    }, {
        title: '中心名称',
        dataIndex: 'investigationSiteName',
        key: 'investigationSiteName',
        render: this.renderCommon
    }, {
        title: '筛选失败数量',
        dataIndex: 'count',
        key: 'count',
    }, {
        title: '占比',
        dataIndex: 'percent',
        key: 'percent',
    }]

    getDataSource = () => {
        const { tableData } = this.state;
        const dataSource = [{
            index: '筛选失败数量'
        }, {
            index: '占比'
        }];

        tableData.map((item, index) => {
            if (item.filterFailOptionValue == '合计') {
                dataSource[0][`${item.filterFailOptionValue}_${index}`] = <strong>{item.count}</strong>;
                dataSource[1][`${item.filterFailOptionValue}_${index}`] = <strong>{(item.percent * 100).toFixed(2) + '%'}</strong>;
            } else {
                dataSource[0][`${item.filterFailOptionValue}_${index}`] = item.count;
                dataSource[1][`${item.filterFailOptionValue}_${index}`] = (item.percent * 100).toFixed(2) + '%';
            }
        })
        return dataSource;
    }

    getSiteDataSource = () => {
        const { siteData } = this.state;
        const dataSource = [];
        siteData.map((item, index) => {
            const params = {};
            if (item.filterStatisticTypes && item.filterStatisticTypes.length > 0) {
                item.filterStatisticTypes.map(innerItem => {
                    if (item.investigationName == '合计') {
                        params[`${innerItem.filterFailOptionId}_count`] = <strong>{innerItem.count}</strong>;
                        params[`${innerItem.filterFailOptionId}_per`] = <strong>{(innerItem.percent * 100).toFixed(2) + '%'}</strong>;
                    } else {
                        params[`${innerItem.filterFailOptionId}_count`] = innerItem.count;
                        params[`${innerItem.filterFailOptionId}_per`] = (innerItem.percent * 100).toFixed(2) + '%';
                    }
                });
            }
            dataSource.push({
                index: item.investigationName == '合计' ? <strong>合计</strong> : (index + 1),
                investigationSiteCode: item.investigationSiteCode,
                investigationSiteName: item.investigationSiteName,
                ...params,
            });
        });
        return dataSource;
    }
    
    getSecondDataSource = () => {
        const { tableData } = this.state;
        const dataSource = [];
        tableData.map((item, index) => {
            dataSource.push({
                index: item.investigationName == '合计' ? <strong>合计</strong> : (index + 1),
                investigationSiteCode: item.investigationSiteCode,
                investigationSiteName: item.investigationSiteName,
                count: item.investigationName == '合计' ? <strong>{item.filterStatisticTypes[0].count}</strong>: item.filterStatisticTypes[0].count,
                percent: item.investigationName == '合计' ? <strong>{(item.filterStatisticTypes[0].percent * 100).toFixed(2) + '%'}</strong> : (item.filterStatisticTypes[0].percent * 100).toFixed(2) + '%',
            });
        });
        return dataSource;
    }

    getContent = () => {
        const { tableData, siteData = [], params, activeKey } = this.state;
        const { optionDeep } = params;
        let width;
        if (activeKey == '0') {
            if (optionDeep == '1') {
                width = tableData.length * 105 + 90;
            } else if (optionDeep == '2' || optionDeep == '-1') {
                width = tableData.length * 140 + 90;
            }
        } else {
            if (optionDeep == '1') {
                if (siteData.length > 0 && siteData[0].filterStatisticTypes) {
                    width = siteData[0].filterStatisticTypes.length * 175 + 325;
                }
            } else if (optionDeep == '2' || optionDeep == '-1') {
                if (siteData.length > 0 && siteData[0].filterStatisticTypes) {
                    width = siteData[0].filterStatisticTypes.length * 175 + 355;
                }
            }
        }
        return (
            <Table
                columns={activeKey == '0' ? this.getColumns() : this.getSiteColumns()}
                dataSource={activeKey == '0' ? this.getDataSource() : this.getSiteDataSource()}
                rowKey={record => record.key}
                scroll={{ x: width }}
                pagination={false}
                bordered
            />
        )
    }

    getPieChartConfig = () => {
        const { data = [], subtitle = '' } = this.state;
        const chartsData = [];
        if (subtitle == '') {
            const list = [...data];
            list.length > 0 && list.pop();
            list.map(item => {
                let name = item.filterFailOptionValue;
                if (item.filterFailOptionValue.length > 20) {
                    name = item.filterFailOptionValue.slice(0, 20) + '···'
                }
                chartsData.push({
                    name,
                    allName: item.filterFailOptionValue,
                    id: item.filterFailOptionId,
                    y: item.percent,
                    count: item.count,
                    drilldown: true
                });
            });
        } else {
            data.map(item => {
                chartsData.push({
                    name: item.investigationSiteName,
                    allName: item.investigationSiteName,
                    y: item.filterStatisticTypes[0].percent,
                    count: item.filterStatisticTypes[0].count,
                });
            });
        }
        
        const _this = this;
        return {
            chart: {
                type: 'pie',
                events: {
                    drilldown: function (e) {
                        if (e.point.allName != '其它') {
                            _this.loadSecondData({filterFailOptionId: e.point.id, filterFailOptionValue: e.point.allName});
                        }
                    }
                }
            },
            title: {
                text: ''
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                x: 0,
                y: 20,
                layout: 'vertical',
            },
            tooltip: {
                headerFormat: '',
                pointFormat: '{point.allName}: <b>{point.count}</b>, <b>{point.percentage:.2f}%</b>'
            },
            plotOptions: {
                pie: {
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false,
                    },
                    showInLegend: true,
                },
            },
            series: [{
				colorByPoint: true,
				data: chartsData
            }],
            credits: {
                enabled: false
            }
        };
    }

    getChartConfig = () => {
        const { data } = this.state;
        const categories = [],
            series = [{
                name: '本中心筛选失败数量',
                data: [],
            }, {
                name: '所有中心筛选失败数量',
                data: [],
            }];
        data.map((item, index) => {
            if ((index < data.length - 1) && index < 20) {
                categories.push(item.filterFailOptionValue);
                series[0].data.push(item.siteCount);
                series[1].data.push(item.allCount);
            }
        });
        return {
            chart: {
                type: 'column',
            },
            title: {
                text: ''
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                x: 0,
                y: 40,
                layout: 'vertical',
            },
            xAxis: {
                categories,
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: '筛选失败数量'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.0f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                column: {
                    borderWidth: 0
                }
            },
            series,
            credits: {
                enabled: false
            }
        };
    }

    getDetailColumns = () => {
        const { tableData = [], params } = this.state;
        const { optionDeep } = params;
        let width;
        if (optionDeep == '1') {
            width = 105;
        } else if (optionDeep == '2' || optionDeep == '-1') {
            width = 140;
        }

        const columns = [{
            title: '筛选失败原因',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 90
        }];

        tableData.map((item, index) => {
            columns.push({
                title: item.filterFailOptionValue,
                dataIndex: `${item.filterFailOptionValue}_${index}`,
                key: `${item.filterFailOptionValue}_${index}`,
                width,
            })
        });
        return columns;
    }

    getDetailDataSource = () => {
        const { tableData = [] } = this.state;
        const dataSource = [{
            index: '本中心筛选失败数量'
        }, {
            index: '本中心各选项占比'
        }, {
            index: '所有中心筛选失败数量'
        }, {
            index: '本中心 VS 所有中心'
        }];

        tableData.map((item, index) => {
            if (item.filterFailOptionValue == '合计') {
                dataSource[0][`${item.filterFailOptionValue}_${index}`] = <strong>{item.siteCount}</strong>;
                dataSource[1][`${item.filterFailOptionValue}_${index}`] = <strong>{(item.sitePercent * 100).toFixed(2) + '%'}</strong>;
                dataSource[2][`${item.filterFailOptionValue}_${index}`] = <strong>{item.allCount}</strong>;
                dataSource[3][`${item.filterFailOptionValue}_${index}`] = <strong>{(item.siteVsAllPercent * 100).toFixed(2) + '%'}</strong>;
            } else {
                dataSource[0][`${item.filterFailOptionValue}_${index}`] = item.siteCount;
                dataSource[1][`${item.filterFailOptionValue}_${index}`] = (item.sitePercent * 100).toFixed(2) + '%';
                dataSource[2][`${item.filterFailOptionValue}_${index}`] = item.allCount;
                dataSource[3][`${item.filterFailOptionValue}_${index}`] = (item.siteVsAllPercent * 100).toFixed(2) + '%';
            }
        })
        return dataSource;
    }

    getTable = () => {
        const { loading, data, params } = this.state;
        const { optionDeep } = params;
        let width;
        if (optionDeep == '1') {
            width = data.length * 105 + 90;
        } else if (optionDeep == '2' || optionDeep == '-1') {
            width = data.length * 140 + 90;
        }
        return (
            <div style={{paddingTop: 24}}>
                <Table
                    columns={this.getDetailColumns()}
                    dataSource={this.getDetailDataSource()}
                    rowKey={record => record.key}
                    scroll={{ x: width }}
                    loading={loading}
                    pagination={false}
                    bordered
                />
            </div>
        )
    }

    getSecondTable = () => {
        const { loading } = this.state;
        return (
            <div style={{paddingTop: 24}}>
                <Table
                    columns={this.getSecondColumns()}
                    dataSource={this.getSecondDataSource()}
                    rowKey={record => record.key}
                    loading={loading}
                    pagination={false}
                    bordered
                />
            </div>
        )
    }

    render() {
        const { siteId } = sessionStorage;
        const { params, panes, activeKey, subtitle = '', loading, siteList } = this.state;
        const { investigationSiteId, optionDeep } = params;
        const config = investigationSiteId == '0' ? this.getPieChartConfig() : this.getChartConfig();
        return (
            <div className="content primary-tabs-active">
                <SideNav selectKey='/summary/filter' />
                <div className="main">
                    <div className="T-tit">
                        <div className="txt">
                            <h3 style={{ marginBottom: 10 }}>筛选失败原因统计{subtitle != '' && <span style={{fontSize: 13}}>-{subtitle}</span>}</h3>
                        </div>
                    </div>
                    {
                        subtitle == ''
                        ?
                            <div style={{marginBottom: 10}}>
                                {
                                    siteId == '0' &&
                                    <Select
                                        value={investigationSiteId}
                                        style={{width: 180, marginRight: 20}}
                                        onChange={value => this.handleSelectChange(value, 'investigationSiteId')}
                                    >
                                        { siteList.map(i => <Option key={i.investigationSiteId}>{i.investigationSiteName}</Option>) }
                                    </Select>
                                }
                                <Select
                                    style={{width: 80}}
                                    value={optionDeep}
                                    onChange={value => this.handleSelectChange(value, 'optionDeep')}
                                >
                                    <Option value="1">一级选项</Option>
                                    <Option value="2">二级选项</Option>
                                    <Option value="-1">末级选项</Option>
                                </Select>
                            </div>
                        :
                            <div style={{marginBottom: 10}}>
                                <div onClick={this.loadData} style={{float: 'right', marginRight: 22, color: '#5750c9b3', cursor: 'pointer'}}><i className="icon iconfont">&#xe63d;</i> 返回上一层</div>
                            </div>
                    }
                    {
                        optionDeep != '-1' &&
                        <div className="charts" style={{ marginBottom: 10 }}>
                            <Highcharts config={{ ...config, ...chartsConfig }} />
                        </div>
                    }
                    <div style={optionDeep == '-1' ? {position: 'relative', marginTop: 30} : {position: 'relative'}}>
                        <Icon type="download" onClick={this.export} style={{position: 'absolute', right: 10, color: '#51aaec', cursor: 'pointer', zIndex: 1}} />
                        {
                            investigationSiteId == '0'
                            ?
                                subtitle == ''
                                ?
                                    <Spin spinning={loading}>
                                        <Tabs
                                            onChange={this.onChange}
                                            activeKey={activeKey}
                                            type="card"
                                        >
                                            {panes.map(pane => <TabPane animated={false} tab={pane.title} key={pane.key} closable={pane.closable}>{pane.content}</TabPane>)}
                                        </Tabs>
                                    </Spin>
                                :
                                    this.getSecondTable()
                            :
                            this.getTable()
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default ChartsFilter;



// WEBPACK FOOTER //
// ./src/components/summary/Filter.js